export default "__VITE_ASSET__CNZJB4eK__"